import React from 'react';
import CoreLink from '../../components/core_link';
import SanitizedRender from '../../components/sanitized_render';

export interface ICMSPageHeadProps {
  title: string;
  subtitle?: string;
  imageUrl?: string;
  actionUrl?: string;
  actionText?: string;
  authorName?: string;
  goLiveAt?: string;
  pageType?: string;
}

export default class CMSPageHead extends React.Component<ICMSPageHeadProps, null> {
  getBackgroundImageStyle() {
    if (!this.props.imageUrl) { return null; }

    return {
      style: { backgroundImage: `url('${this.props.imageUrl}')` },
    };
  }

  renderText() {
    if (!this.props.title) return null;

    return (
      <header className="cms-page-head__text">
        <div className="cms-page-head__text__inner">
          <div>
            <SanitizedRender
              htmlTag="h1"
              className="cms-page-head__title"
              html={this.props.title}
              inlineTagsOnly
            />
            {this.props.subtitle &&
              <SanitizedRender
                htmlTag="h2"
                className="cms-page-head__subtitle"
                html={this.props.subtitle}
                inlineTagsOnly
              />
            }
          </div>
          <div>
            {this.props.actionUrl &&
              <CoreLink
                className="cms-page-head__action"
                to={this.props.actionUrl}
              >
                {this.props.actionText}
              </CoreLink>
            }
          </div>
        </div>
      </header>
    );
  }

  render() {
    return (
      <div className="cms-page-head">
        <div
          className="cms-page-head__image"
          {...this.getBackgroundImageStyle()}
        />
        <div className="cms-page-head__container">
          <div className="cms-page-head__offset">
            {this.renderText()}
          </div>
        </div>
      </div>
    );
  }
}
